export default "__VITE_ASSET__BeswAqDh__"